// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/text-select.js';

import { paths } from '../generated/text-select';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('text-select', Original, paths);
